import Heading4 from './Heading4';
export default Heading4;
